import React from 'react';
import Card from "../ui/card/card";
import YouAreAnonymous from "../ui/anonymous/anonymous";
import PoweredBy from "../ui/poweredBy/poweredBy";
import HelpLineTitle from "../ui/helpline-title/helplineTitle";
import { styled } from "styled-components";
import { useNavigate, useParams } from "react-router";
import ShareFeedback from "../ui/shareFeedback/shareFeedback";

const Wrapper = styled.div`
  .HelpLineTitle {
    width: 300px;
    padding: 10px;
    position: absolute;
    left: 20px;
    top: 20px;
    background-color: #FFF;
    border-radius: 20px;
    -webkit-box-shadow: 2px 3px 19px -9px rgba(66, 68, 90, 1);
    -moz-box-shadow: 2px 3px 19px -9px rgba(66, 68, 90, 1);
    box-shadow: 2px 3px 19px -9px rgba(66, 68, 90, 1);
    p {
      font-size: 12px;
      margin: 0px;
    }
    img {
      width: 68px;
      margin-top: 0px;
    }
  }
  
  @media (max-width: 768px) {
    padding-top: 60px;
    
    .HelpLineTitle {
      width: 250px;
    }
    
    .anonymousBlock {
      padding: 8px;
      span {
        display: none;
      }
    }
  }
`;

const FeedbackPage = () => {

  const navigate = useNavigate();
  const { companyId, categoryId } = useParams();

  return (
    <Wrapper>
      <HelpLineTitle />
      <YouAreAnonymous show={true} />
      <div className='root'>
        <Card>
          <ShareFeedback onSubmit={() => navigate(`/${companyId}/question/${categoryId}/phoneNumber`)} />
        </Card>
      </div>
      <PoweredBy />
    </Wrapper>
  );
};

export default FeedbackPage;
